/**
 * Fallback on Cookies if Local Storage isn't supported.
 * Which it isn't in Safari private mode
 */
export class CookieStore {

  static create (token) {
    document.cookie = 'oauth=' + JSON.stringify(token);
  }

  static read () {
    var nameEQ = 'oauth=';
    var ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) {
        return JSON.parse(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }

  static remove () {
    this.create('');
  }

}

export class LocalStorageStore {

  persist (token) {
    try {
      localStorage.setItem('oauth', JSON.stringify(token));
    } catch (e) {
      CookieStore.create(token);
      console.log(e);
    }
  }

  reset () {
    CookieStore.remove();
    localStorage.removeItem('oauth');
  }

  getOauth () {
    let oauth;

    try {
      oauth = localStorage.getItem('oauth');
    } catch (e) {
      console.log(e);
    }

    if (oauth) {
      try {
        return JSON.parse(oauth);
      } catch (e) {
        return null;
      }
    }

    let cookieOuath = CookieStore.read();

    return cookieOuath === '' ? null : cookieOuath;
  }

  get isEmpty () {
    let oauth;

    try {
      oauth = localStorage.getItem('oauth');
    } catch (e) {
      console.log(e);
      return false;
    }

    if (!oauth) {
      oauth = CookieStore.read();
    }

    if (oauth) {
      return false;
    } else {
      return true;
    }
  }
}




/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/service/local-storage-store.js
 **/